import { useQueryClient } from '@tanstack/react-query';

const useQueryData = <T>(key: Readonly<string[]>) => {
	const queryClient = useQueryClient();
	return queryClient.getQueryData<T>(key);
};

export default useQueryData;
